// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__+73Vp","icon":"styles_icon__Crtbf","editor":"styles_editor__8t-eA"};